import React from 'react';
import {startCase} from 'lodash';
import PropTypes from 'prop-types';

import {Heading, ListGroup, ListGroupItem, Text} from '@albert-io/atomic';

import LoadingIndicator from 'generic/LoadingIndicator.react';

import {AuthorDashboardConsumer} from '../AuthorDashboardProvider/AuthorDashboardConsumer.react';

import {AuthorDashboardBarChart} from './AuthorDashboardBarChart.react';
import AuthorDashboardMetricsQuestionDifficulties from './AuthorDashboardMetricsQuestionsDifficulties.react';
import AuthorDashboardMetricsTypeBar from './AuthorDashboardMetricsTypeBar/AuthorDashboardMetricsTypeBar.react';
import AuthorDashboardMetricsDropdowns from './AuthorDashboardMetricsDropdowns.react';

import './author-dashboard-metrics.scss';

const typeBarPercentage = (currSubjectTotal, allTotal) => {
  return (currSubjectTotal / allTotal) * 100;
};

const makeTypeBars = (questionTypes) => {
  const {all} = questionTypes;
  return Object.entries(questionTypes).map(([key, value], index) => {
    return (
      value !== 0 &&
      key !== 'all' && (
        <div key={index}>
          <div className='author-dashboard-metrics__type-container'>
            <Text emphasis='medium' className='author-dashboard-metrics__type-name'>
              {startCase(key)}
            </Text>
            <Text emphasis='lowest' className='author-dashboard-metrics__type-count'>
              {value}
            </Text>
          </div>
          <AuthorDashboardMetricsTypeBar progress={typeBarPercentage(value, all)} />
        </div>
      )
    );
  });
};

const AuthorDashboardMetrics = ({isMobile}) => {
  return (
    <AuthorDashboardConsumer field='isMetricsLoaded'>
      {(context) => {
        return (
          <div>
            <Heading size='m' className='author-dashboard-metrics__header u-mar-b_3'>
              Metrics
            </Heading>
            <ListGroup className='author-dashboard-metrics__container'>
              <ListGroupItem paddingLevel={3}>
                <AuthorDashboardMetricsDropdowns data={context} />
              </ListGroupItem>
              {context.isMetricsLoaded ? (
                <div>
                  <ListGroupItem className='author-dashboard-metrics__stats author-dashboard-metrics__list-group-item'>
                    <div className='author-dashboard-metrics__publish-total'>
                      <Text emphasis='low' className='author-dashboard-metrics__published-text'>
                        Questions Published
                      </Text>
                      <Heading size='xl' className='author-dashboard-metrics__published-stat'>
                        {context.questionDifficulties.all}
                      </Heading>
                    </div>
                    <AuthorDashboardMetricsQuestionDifficulties
                      style={{width: '50%'}}
                      questionDifficulties={context.questionDifficulties}
                    />
                  </ListGroupItem>
                  {!isMobile && (
                    <ListGroupItem
                      className='author-dashboard-metrics__list-group-item'
                      footer={context.questionTypes.all === 0}
                    >
                      <Heading
                        size='xs'
                        emphasis='lowest'
                        className='author-dashboard-metrics__subheader u-mar-b_3'
                      >
                        Published
                      </Heading>
                      <AuthorDashboardBarChart chartData={context.publishedQuestionDates} />
                    </ListGroupItem>
                  )}
                  {(context.questionTypes.all !== 0 || !context.questionTypes) && (
                    <ListGroupItem
                      className='author-dashboard-metrics__list-group-item author-dashboard-metrics__type-bars-container'
                      footer
                    >
                      <Heading
                        size='xs'
                        emphasis='lowest'
                        className='author-dashboard-metrics__subheader u-mar-b_3'
                      >
                        Question Types
                      </Heading>
                      {makeTypeBars(context.questionTypes)}
                    </ListGroupItem>
                  )}
                </div>
              ) : (
                <ListGroupItem footer>
                  <LoadingIndicator />
                </ListGroupItem>
              )}
            </ListGroup>
          </div>
        );
      }}
    </AuthorDashboardConsumer>
  );
};

AuthorDashboardMetrics.propTypes = {
  isMobile: PropTypes.bool
};

export default AuthorDashboardMetrics;
